import React, { Component } from 'react'
import { withStyles } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { ButtonBase } from '@material-ui/core'
import AccountImage from '../Image/AccountImage';
import { card } from "assets/jss/material-dashboard-pro-react";

const styles = {

}

class CustomerBlock extends Component {
    render () {
        const { classes, account } = this.props;

        return (
            <ButtonBase to={this.props.link} component={Link} style={{ borderRadius: 8, boxShadow: card.boxShadow, margin: '6px 4px' }}>
                <div style={{ width: 130, height: 180, padding: 15, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <AccountImage {...account} accountSize={90} companySize={28} />
                    <span style={{ paddingTop: 10, fontSize: 17, fontWeight: '400' }}>{account.account_no}</span>
                    <span style={{ paddingTop: 4, textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: 100 }}>{account.name}</span>
                </div>
            </ButtonBase>
        )
    }
}

export default withStyles(styles)(CustomerBlock);